import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBuilding, FaFileSignature, FaChartLine, FaMapMarkerAlt, FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';

import Header from '../components/Header';
import { AlertCircleIcon, CheckIcon } from 'lucide-react';

const BusinessCreationForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    // Informations générales
    companyName: "",
    companyType: "",
    businessSector: "",

    // Détails juridiques
    registrationNumber: "",
    taxIdentificationNumber: "",
    legalStatus: "",

    // Informations de contact
    headOfficeAddress: "",
    email: "",
    phoneNumber: "",
    website: "",

    // Informations financières
    initialCapital: "",
    expectedAnnualTurnover: "",
    fundingSource: "",

    // Ressources humaines
    numberOfEmployees: "",
    managementTeamSize: "",

    // Détails supplémentaires
    businessDescription: "",
    strategicGoals: "",
    mainProducts: "",
  });

  const [currentStep, setCurrentStep] = useState(1);
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "registrationNumber" && value.length > 13) {
      setFormErrors((prev) => ({
        ...prev,
        registrationNumber:
          "Le numéro d'immatriculation ne peut pas dépasser 13 caractères",
      }));
      return; // Empêche la mise à jour si la longueur dépasse 13
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Supprime l'erreur si la saisie devient valide
    if (name === "registrationNumber" && value.length === 13) {
      setFormErrors((prev) => ({
        ...prev,
        registrationNumber: "",
      }));
    }

    // Validation en temps réel pour le numéro RCCM
    if (name === "taxIdentificationNumber") {
      const rccmRegex = /^[A-Z]{2}\/[A-Z]{3}\/\d{2}_[A-Z]_\d{4}$/;
      if (!rccmRegex.test(value)) {
        // Correction ici
        setFormErrors((prev) => ({
          ...prev,
          taxIdentificationNumber:
            "Le numéro RCCM doit respecter le format RB/COT/25_B_3915",
        }));
      } else {
        setFormErrors((prev) => ({
          ...prev,
          taxIdentificationNumber: "",
        }));
      }
    }
  };

  const validateStep = () => {
    const errors = {};

    switch (currentStep) {
      case 1:
        if (!formData.companyName)
          errors.companyName = "Le nom de l'entreprise est requis";
        if (!formData.companyType)
          errors.companyType = "Le type d'entreprise est requis";
        if (!formData.businessSector)
          errors.businessSector = "Le secteur d'activité est requis";
        break;
      case 2:
        if (!formData.registrationNumber) {
          errors.registrationNumber = "Le numéro IFU est requis";
        } else if (formData.registrationNumber.length !== 13) {
          errors.registrationNumber =
            "Le numéro IFU doit contenir exactement 13 caractères";
        }
        if (!formData.legalStatus)
          errors.legalStatus = "Le statut juridique est requis";

        if (!formData.taxIdentificationNumber) {
          errors.taxIdentificationNumber = "Le numéro RCCM est requis";
        } else {
          const rccmRegex = /^[A-Z]{2}\/[A-Z]{3}\/\d{2}_[A-Z]_\d{4}$/;
          if (!rccmRegex.test(formData.taxIdentificationNumber)) {
            // Correction ici
            errors.taxIdentificationNumber =
              "Le numéro RCCM doit respecter le format RB/COT/25_B_3915";
          }
        }
        break;
      case 3:
        if (!formData.headOfficeAddress)
          errors.headOfficeAddress = "L'adresse du siège est requise";
        if (!formData.email) errors.email = "L'email est requis";
        if (!formData.phoneNumber)
          errors.phoneNumber = "Le numéro de téléphone est requis";
        break;
      default:
        break;
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const nextStep = () => {
    if (validateStep()) {
      setCurrentStep((prev) => Math.min(prev + 1, 4));
    }
  };

  const prevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    if (validateStep()) {
      // Logique de soumission du formulaire
      console.log("Formulaire soumis:", formData);
      // console.log("Formulaire soumis:", formData);
      // Save form data to database by axios request
      axios
        .post(process.env.React_App_base_url + "newclient", {
          company_name: formData.companyName,
          forme_juridique: formData.companyType,
          secteur_activite: formData.businessSector,
          num_registre_commerce: formData.registrationNumber,
          num_ifu: formData.taxIdentificationNumber,
          type_entite: formData.legalStatus,
          company_address: formData.headOfficeAddress,
          email: formData.email,
          phone: formData.phoneNumber,
          website: formData.website || "",
          // "initialCapital": formData.initialCapital,
          // "expectedAnnualTurnover": formData.expectedAnnualTurnover,
          // "fundingSource": formData.fundingSource || "",
          // "numberOfEmployees": formData.numberOfEmployees || "",
          // "managementTeamSize": formData.managementTeamSize || "",
          // "businessDescription": formData.businessDescription || "",
          // "strategicGoals": formData.strategicGoals || "",
          // "mainProducts": formData.mainProducts || ""
        })
        .then((response) => {
          setLoading(false);
          // console.log(response.data);
          const successRes = response.data.status;
          if (successRes === "error") {
            setError(
              "Erreur de données, Vous avez déjà soumis ce formulaire avec cette adresse email: " +
                formData.email +
                ". Veuillez modifier le formulaire et soumettre une nouvelle fois. Si vous avez des doutes, veuillez contacter le service client.. Si vous n'avez pas eu de retour, veuillez nous contacter par mail à l'adresse suivante : expertises@cinef-expertises.com ou par téléphone au +229 01 97 08 46 01. Merci"
            );
          }
          if (successRes === "success") {
            setLoading(false);
            setSuccess(
              "Formulaire soumis avec succès. Nous vous contacterons dans les plus bref delais. Merci."
            );
            setError("");
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(
            "Une erreur s'est produite lors de la soumission du formulaire."
          );
          // console.error(error);
        });

      // Redirection ou affichage de confirmation
      // navigate('/confirmation');
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-step">
            <h2>
              <FaBuilding /> Informations Générales
            </h2>
            <div className="form-group">
              <label>Nom de l'Entité</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Nom complet de l'entreprise"
              />
              {formErrors.companyName && <span className="error">{formErrors.companyName}</span>}
            </div>
            <div className="form-group">
              <label>Forme Juridique</label>
              <select
                name="companyType"
                value={formData.companyType}
                onChange={handleChange}
              >
                <option value="">Sélectionnez un type</option>
                <option value="SARL">Sarl/SAS/SA/SNC</option>
                <option value="SA">SCI</option>
                <option value="SA">SCP</option>
                <option value="SAS">Société Coopérative</option>
                <option value="EURL">Entreprise Individuelle</option>
                <option value="EURL">Association /ONG</option>
              </select>
              {formErrors.companyType && (
                <span className="error">{formErrors.companyType}</span>
              )}
            </div>
            <div className="form-group">
              <label>Secteur d'Activité</label>
              <select
                name="businessSector"
                value={formData.businessSector}
                onChange={handleChange}
              >
                <option value="">Secteur d'activité</option>
                <option value="agriculture">Agriculture</option>
                <option value="btp">BTP</option>
                <option value="commerce">Commerce</option>
                <option value="finance">Finance</option>
                <option value="tech">Technologies</option>
                <option value="hotellerie">Hotellerie-Restauration</option>
                <option value="industrie">Industrie</option>
                <option value="LIBERALE">Profession Libérale</option>
                <option value="santé">Santé</option>
                <option value="service">Services</option>
                <option value="transport">Transport</option>
                <option value="autre">Autres</option>
              </select>
              {formErrors.businessSector && (
                <span className="error">{formErrors.businessSector}</span>
              )}
            </div>
          </div>
        );
      case 2:
        return (
          <div className="form-step">
            <h2>
              <FaFileSignature /> Détails Juridiques
            </h2>
            <div className="form-group">
              <label> Numéro d'Identification Fiscale</label>
              <input
                type="text"
                name="registrationNumber"
                value={formData.registrationNumber}
                onChange={handleChange}
                placeholder="Numéro IFU"
              />
              {formErrors.registrationNumber && (
                <span className="error">{formErrors.registrationNumber}</span>
              )}
            </div>
            <div className="form-group">
              <label>Numéro d'Immatriculation</label>
              <input
                type="text"
                name="taxIdentificationNumber"
                value={formData.taxIdentificationNumber}
                onChange={handleChange}
                placeholder="Numéro RCCM"
              />
              {formErrors.taxIdentificationNumber && (
                <span className="error">
                  {formErrors.taxIdentificationNumber}
                </span>
              )}
            </div>
            <div className="form-group">
              <label>Type d'entité</label>
              <select
                name="legalStatus"
                value={formData.legalStatus}
                onChange={handleChange}
              >
                <option value="">Sélectionnez un statut</option>
                <option value="startup">Startup</option>
                <option value="pme">PME/PMI</option>
                <option value="grandGroupe">Grand Groupe</option>
                <option value="autoEntrepreneur">Auto-Entrepreneur</option>
                <option value="microentreprise">Micro-Enntreprise</option>
              </select>
              {formErrors.legalStatus && <span className="error">{formErrors.legalStatus}</span>}
            </div>
          </div>
        );
      case 3:
        return (
          <div className="form-step">
            <h2><FaMapMarkerAlt /> Coordonnées</h2>
            <div className="form-group">
              <label>Adresse du Siège Social</label>
              <input
                type="text"
                name="headOfficeAddress"
                value={formData.headOfficeAddress}
                onChange={handleChange}
                placeholder="Adresse complète"
              />
              {formErrors.headOfficeAddress && <span className="error">{formErrors.headOfficeAddress}</span>}
            </div>
            <div className="form-group">
              <label>Email de Contact</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email officiel"
              />
              {formErrors.email && (
                <span className="error">{formErrors.email}</span>
              )}
            </div>
            <div className="form-group">
              <label>Numéro de Téléphone</label>
              <input
                type="tel"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Numéro de téléphone principal"
              />
              {formErrors.phoneNumber && (
                <span className="error">{formErrors.phoneNumber}</span>
              )}
            </div>
            <div className="form-group">
              <label>Site Web (Optionnel)</label>
              <input
                type="url"
                name="website"
                value={formData.website}
                onChange={handleChange}
                placeholder="URL du site web"
              />
            </div>
          </div>
        );
      case 4:
        return (
          <></>
          // <div className="form-step">
          //   <h2><FaChartLine /> Perspectives Financières</h2>
          //   <div className="form-group">
          //     <label>Capital Initial</label>
          //     <input
          //       type="number"
          //       name="initialCapital"
          //       value={formData.initialCapital}
          //       onChange={handleChange}
          //       placeholder="Montant du capital initial"
          //     />
          //   </div>
          //   <div className="form-group">
          //     <label>Chiffre d'Affaires Prévisionnel</label>
          //     <input
          //       type="number"
          //       name="expectedAnnualTurnover"
          //       value={formData.expectedAnnualTurnover}
          //       onChange={handleChange}
          //       placeholder="Estimation du chiffre d'affaires annuel"
          //     />
          //   </div>
          //   <div className="form-group">
          //     <label>Source de Financement</label>
          //     <select
          //       name="fundingSource"
          //       value={formData.fundingSource}
          //       onChange={handleChange}
          //     >
          //       <option value="">Sélectionnez une source</option>
          //       <option value="personnalFunds">Fonds Personnels</option>
          //       <option value="bankLoan">Prêt Bancaire</option>
          //       <option value="investors">Investisseurs</option>
          //       <option value="publicSubsidies">Subventions Publiques</option>
          //     </select>
          //   </div>
          //   <div className="form-group">
          //     <label>Description de l'Entreprise</label>
          //     <textarea
          //       name="businessDescription"
          //       value={formData.businessDescription}
          //       onChange={handleChange}
          //       placeholder="Décrivez brièvement votre entreprise et son activité"
          //       rows="4"
          //     />
          //   </div>
          // </div>
        );
      default:
        return null;
    }
  };

  // Loading on click
  if (loading === true) {
    return (
      <p
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "24px",
          fontWeight: "bold",
          color: "rgba(29, 14, 249, 0.8)",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "5px",
          padding: "10px 20px",
          cursor: "default",
        }}
      >
        {" "}
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <g
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            >
              <path
                stroke-dasharray="16"
                stroke-dashoffset="16"
                d="M12 3c4.97 0 9 4.03 9 9"
              >
                <animate
                  fill="freeze"
                  attributeName="stroke-dashoffset"
                  dur="0.3s"
                  values="16;0"
                />
                <animateTransform
                  attributeName="transform"
                  dur="1.5s"
                  repeatCount="indefinite"
                  type="rotate"
                  values="0 12 12;360 12 12"
                />
              </path>
              <path
                stroke-dasharray="64"
                stroke-dashoffset="64"
                stroke-opacity="0.3"
                d="M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z"
              >
                <animate
                  fill="freeze"
                  attributeName="stroke-dashoffset"
                  dur="1.2s"
                  values="64;0"
                />
              </path>
            </g>
          </svg>{" "}
        </span>{" "}
        <span>Loading...</span>{" "}
      </p>
    );
  }

  return (
    <>
      <Header />
      <div className="business-creation-container">
        <div className="form-container">
          {/* Display success message */}
          {success && (            
            <div className="alert alert-success">
            <CheckIcon />  {success}
            </div>
          )}

          {/* Display error message */}
          {error && (
            <div className="alert alert-danger">
             <AlertCircleIcon /> {error}
            </div>
          )}

          <div className="form-progress">
            {[1, 2, 3, 4].map(step => (
              <div
                key={step}
                className={`progress-step ${currentStep >= step ? 'active' : ''}`}
              />
            ))}
          </div>

          <form onSubmit={handleSubmit}>
            {renderStep()}

            <div className="form-navigation">
              {currentStep > 1 && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={prevStep}
                >
                  Précédent
                </button>
              )}

              {currentStep < 4 ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={nextStep}
                >
                  Suivant
                </button>
              ) : (
                // <></>
                <button
                  type="submit"
                  className="btn btn-success"
                >
                  <FaCheckCircle /> 
                  {/* Soumettre le Dossier */}
                </button>
              )}
            </div>
          </form>
        </div>

        <style jsx>{`
        .business-creation-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          padding: 20px;
        }

        .form-container {
          background: white;
          border-radius: 15px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          width: 100%;
          max-width: 600px;
          padding: 40px;
          position: relative;
        }

        .form-progress {
          display: flex;
          justify-content: space-between;
          margin-bottom: 30px;
        }

        .progress-step {
          flex: 1;
          height: 4px;
          background: #e0e0e0;
          margin: 0 5px;
          transition: background 0.3s ease;
        }

        .progress-step.active {
          background: #008A44;
        }

        .form-step h2 {
          color: #008A44;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .form-group {
          margin-bottom: 15px;
        }

        .form-group label {
          display: block;
          margin-bottom: 5px;
          color: #333;
        }

        .form-group input,
        .form-group select,
        .form-group textarea {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 5px;
          transition: border-color 0.3s ease;
        }

        .form-group input:focus,
        .form-group select:focus,
        .form-group textarea:focus {
          border-color: #008A44;
          outline: none;
        }

        .error {
          color: red;
          font-size: 0.8em;
          margin-top: 5px;
        }

        .form-navigation {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
        }

        .btn {
          padding: 10px 20px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .btn-secondary {
          background: #6c757d;
          color: white;
        }

        .btn-primary {
          background: #008A44;
          color: white;
        }

        .btn-success {
          background: #28a745;
          color: white;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .btn:hover {
          opacity: 0.9;
        }
      `}</style>
      </div>
    </>
  );
};

export default BusinessCreationForm;
